import MsButton from './MsButton.vue';

MsButton.install = Vue => Vue.component(MsButton.name, MsButton);

export default MsButton;
